import Danish from './date-field.da';

function getDatepicker() {
    return import(/* webpackChunkName: "datepicker2" */ 'flatpickr');
}

function getDatepickerRangePlugin() {
    return import(/* webpackChunkName: "datepicker2range" */ 'flatpickr/dist/plugins/rangePlugin');
}
export default function bootstrapDatepicker(element, customConfiguration) {
    const defaultConfiguration = {
        locale: Danish,
        dateFormat: 'd-m-Y'
    };

    let configuration = Object.assign({}, defaultConfiguration, customConfiguration);

    getDatepicker().then(datepicker => {
        if (typeof configuration.separateRageField !== 'undefined') {
            getDatepickerRangePlugin().then(RangePlugin => {
                configuration.plugins = [new RangePlugin({ input: configuration.separateRageField })];
                datepicker(element, configuration);
            });
        } else {
            datepicker(element, configuration);
        }
    });
}
